import React, { FC } from 'react';
import { ConstantsCodeType } from 'src/types/constantsCodes';
import translate from '@translate';
import Dialog from 'src/components/Dialog';
import Grid, { GridItem } from 'src/components/Grid';
import OptionsSimpleTable from 'src/components/OptionsSimpleTable';

export interface ColumnOptionsProps {
    productTypeCodes: ConstantsCodeType[];
    expeditionMethodCodes: ConstantsCodeType[];
    boolNumberCodes: ConstantsCodeType[];
    scanImeiSnCodes: ConstantsCodeType[];
    currencyCodes: ConstantsCodeType[];
    onClose: () => void;
}

const ColumnOptions: FC<ColumnOptionsProps> = (props) => {
    return (
        <Dialog
            maxWidth="sm"
            title={translate('productsImport.columnsOptions')}
            onClose={props.onClose}
            sx={{
                paddingBottom: 0,
                '& .MuiDialogTitle-root': { paddingBottom: 0 },
            }}
        >
            <Grid sx={{ paddingTop: 0 }}>
                <GridItem cols={8}>
                    <Grid>
                        <GridItem cols={10}>
                            <OptionsSimpleTable keyText="PRODUCT_TYPE" options={props.productTypeCodes} />
                        </GridItem>
                        <GridItem cols={10}>
                            <OptionsSimpleTable
                                keyText="EXPEDITION_METHOD"
                                options={props.expeditionMethodCodes}
                                onlyValue
                            />
                        </GridItem>
                        <GridItem cols={10}>
                            <OptionsSimpleTable keyText="SCAN_IMEI_SN_TYPE" options={props.scanImeiSnCodes} />
                        </GridItem>
                    </Grid>
                </GridItem>
                <GridItem cols={2}>
                    <OptionsSimpleTable keyText="UNIT_PRICE" options={props.currencyCodes.slice(0, 15)} onlyValue />
                </GridItem>
                <GridItem cols={2}>
                    <OptionsSimpleTable keyText=" " options={props.currencyCodes.slice(-15)} onlyValue />
                </GridItem>
            </Grid>
        </Dialog>
    );
};

export default ColumnOptions;
